const PERCENT_FACTOR = 100;

/** Share of the total as a 0–100 percentage, guarded against divide-by-zero. */
export const calculatePercentageOfTotal = (count: number, totalCount: number): number =>
  totalCount === 0 ? 0 : (count / totalCount) * PERCENT_FACTOR;
